import { useEffect, useState } from 'react';
import { UserSettingsModal } from '@/components/UserSettingsModal';
import { onAppEvent } from '@/lib/appEvents';

/** Keep one settings session alive when responsive sidebars mount/unmount. */
export function SettingsHost() {
  const [session, setSession] = useState<{ initialTab?: string } | null>(null);
  useEffect(() => onAppEvent('settings:open', (detail) => {
    setSession((current) => current ?? { initialTab: detail?.tab });
  }), []);
  return <UserSettingsModal open={session !== null} initialTab={session?.initialTab} onClose={() => setSession(null)} />;
}
